const getInitials = (firstName?: string) => {
	const first = firstName?.[0] || "";
	return first.toUpperCase();
};

export { getInitials };
